"use strict";
exports.pokemon = {
    list: [],
    map: {},
    names: []
};
for (var _i = 0, _a = require('./pokemon.json'); _i < _a.length; _i++) {
    var obj = _a[_i];
    var item = obj;
    exports.pokemon.list[item.id] = item;
    exports.pokemon.map[item.name] = item;
    exports.pokemon.names.push(item.name);
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/pokemon.tsx
 ** module id = 254
 ** module chunks = 0
 **/